// Le tirage des équipes (D-175 lot 1, D-176) : la fiche « Pour les tirages » (table draw_profiles) et le tirage d'une
// séance ou d'un jeu (draw_pool). La base fait le tri : le staff de l'équipe et le responsable technique seulement ; ni la
// joueuse, ni ses parents, ni le bureau qui n'encadre pas l'équipe, ni les autres équipes, ni l'anonyme. Effacée en fin
// de saison (saison archivée, ou finie : migration 20261108000000_tirage.sql).
import { supabase } from './supabase';
import { emptyProfile, readProfile, type DrawPlayer, type DrawProfile } from '../domain/tirage';

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};

/** La fiche d'une joueuse dans cette équipe (vide si rien n'est noté ; null si l'on n'a pas le droit de la lire). */
export async function drawProfile(teamId: string, personId: string): Promise<DrawProfile> {
  const { data, error } = await db().from('draw_profiles').select('level, positions, sex').eq('team_id', teamId).eq('person_id', personId).maybeSingle();
  if (error) throw new Error(error.message);
  return readProfile(data);
}

/** Enregistre la fiche (une seule valeur, sans historique) ; vide, elle est retirée. */
export async function saveDrawProfile(teamId: string, personId: string, p: DrawProfile): Promise<void> {
  const q = emptyProfile(p)
    ? db().from('draw_profiles').delete().eq('team_id', teamId).eq('person_id', personId)
    : db().from('draw_profiles').upsert({ team_id: teamId, person_id: personId, level: p.level, positions: p.positions, sex: p.sex }, { onConflict: 'team_id,person_id' });
  const { error } = await q;
  if (error) throw new Error(error.message);
}

/** Les personnes d'un tirage : leur fiche de l'équipe, leur année de naissance, leur sexe. Sans droit (le bureau seul) :
 *  rien de noté, tout le monde « sans niveau ». */
export async function drawPool(teamId: string, people: string[]): Promise<Map<string, Omit<DrawPlayer, 'id'>>> {
  if (!people.length) return new Map();
  const { data, error } = await db().rpc('draw_pool', { p_team: teamId, p_people: people });
  if (error) return new Map();
  return new Map(((data ?? []) as { person_id: string; level: number | null; positions: string[]; sex: string | null; birth_year: number | null }[]).map(r => {
    const p = readProfile(r);
    return [r.person_id, { level: p.level, postes: p.positions, sex: p.sex, birthYear: r.birth_year }];
  }));
}
